import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./GuestSelector.css";

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export default function GuestSelector({
  open,
  anchorRect,
  adults,
  children,
  onChange,
  onClose,
}) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handleKey = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  if (!open) return null;

  const panelWidth = 280;
  const panelStyle = anchorRect
    ? {
        top: `${anchorRect.bottom + 8}px`,
        left: `${Math.max(
          16,
          Math.min(anchorRect.right - panelWidth, window.innerWidth - panelWidth - 16)
        )}px`,
      }
    : {
        top: "140px",
        left: `${Math.max(16, Math.floor((window.innerWidth - panelWidth) / 2))}px`,
      };

  const update = (key, delta) => {
    const nextAdults =
      key === "adults" ? clamp(adults + delta, 1, 16) : clamp(adults, 1, 16);
    const nextChildren =
      key === "children"
        ? clamp(children + delta, 0, 10)
        : clamp(children, 0, 10);

    onChange?.({ adults: nextAdults, children: nextChildren });
  };

  const content = (
    <div className="hv-guests-overlay" onClick={onClose}>
      <div
        className="hv-guests-panel"
        style={panelStyle}
        onClick={(event) => event.stopPropagation()}
        ref={panelRef}
      >
        <div className="hv-guests-row">
          <div>
            <strong>Adults</strong>
            <p>Age 13+</p>
          </div>
          <div className="hv-guests-stepper">
            <button
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => update("adults", -1)}
            >
              -
            </button>
            <span>{adults}</span>
            <button
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => update("adults", 1)}
            >
              +
            </button>
          </div>
        </div>

        <div className="hv-guests-row">
          <div>
            <strong>Children</strong>
            <p>Age 0-12</p>
          </div>
          <div className="hv-guests-stepper">
            <button
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => update("children", -1)}
            >
              -
            </button>
            <span>{children}</span>
            <button
              type="button"
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => update("children", 1)}
            >
              +
            </button>
          </div>
        </div>

        <div className="hv-guests-footer">
          <button type="button" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === "undefined") {
    return content;
  }

  return createPortal(content, document.body);
}

